




















import {Component, Prop, Vue} from 'vue-property-decorator';
import SimpleCompanySearch from "@/components/common/SimpleCompanySearch.vue";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PersonSearch from "@/components/common/PersonSearch.vue";
import RequestPersonSignatureForFilledDocumentModal
  from "@/components/documents/signing/RequestPersonSignatureForFilledDocumentModal.vue";
import RequestCompanySignatureForFilledDocumentModal
  from "@/components/documents/signing/RequestCompanySignatureForFilledDocumentModal.vue";


@Component({
  components: {PersonSearch, PortalSelect, SingleFileHolder, SimpleCompanySearch}
})
export default class SelectProfileTypeForPrefilledDocumentModal extends Vue {

  @Prop()
  onCreated!: () => void

  select(type: "PERSON" | "COMPANY" | "FORM_9783T"): void {
    this.$modal.hideAll();
    switch (type) {
      case "PERSON":
        this.$modal.show(
            RequestPersonSignatureForFilledDocumentModal,
            {
              onCreated: this.onCreated
            }
        );
        break;
      case "COMPANY":
        this.$modal.show(
            RequestCompanySignatureForFilledDocumentModal,
            {
              onCreated: this.onCreated
            }
        );
        break;

      case "FORM_9783T":
        this.$router.push({name: this.$routeNames.ARCHIVE_SIGNABLE_F9783T, params: this.$route.params});
        break;
    }
  }


}
